import React from "react";

function Ecosystem() {
  return (
    <>
      <div className="container-fluid mt-5 mb-3" id="ecosystem">
        <div className="row">
          <h2 className="heading">$LITTLE Ecosystem</h2>
          <p className="para-sub new home_p">
            Join us on a new path of utility tokens and benefit from the $LITTLE
            <br />
            ecosystem in every way you can imagine
          </p>
        </div>
        <div className="row liquidity">
          <p className="utilitestitle">Liquidity and Rewarding System </p>
          <div className="col-md-3 mob-ecosystem">
            <div className="card p-3 mb-2 ecocard home_little">
              <h2 className="stats">20%</h2>
              <div className="mt-3">
                {" "}
                <p className="ecosystempara2 home_p">
                  of the <b>NFT Revenues</b> are
                  <br /> used to set up MATIC
                  <br /> Pool to reward users.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card p-3 mb-2 ecocard home_little">
              <h2 className="stats">50%</h2>
              <div className="mt-3">
                {" "}
                <p className="ecosystempara2 home_p">
                  of the <b>OS royalties</b> are
                  <br /> used to distribute MATIC
                  <br /> tokens to the community.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card p-3 mb-2 ecocard home_little">
              <h2 className="stats">40%</h2>
              <div className="mt-3">
                {" "}
                <p className="ecosystempara2 home_p">
                  of the <b>Marketplace fees</b>
                  <br /> are used to give MATIC
                  <br /> tokens to the community.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card p-3 mb-2 ecocard home_little">
              <h2 className="stats">80%</h2>
              <div className="mt-3">
                {" "}
                <p className="ecosystempara2 home_p">
                  of{" "}
                  <b>
                    internal Transaction
                    <br /> Fees
                  </b>{" "}
                  are used to provide
                  <br />
                  Liquidity on the Exchange
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row supply_system">
          <p className="utilitestitle">Value and Supply System </p>
          <div className="col-md-6">
            <div className="card p-3 mb-2 ecocard home_little">
              <h2 className="stats">25%</h2>
              <div className="mt-3">
                {" "}
                <p className="ecosystempara2 home_p">
                  of the <b>Opensea Royalties</b> are used to buy up <br />
                  $LITTLE tokens from the exchanges and burn them.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card p-3 mb-2 ecocard home_little">
              <h2 className="stats">20%</h2>
              <div className="mt-3">
                {" "}
                <p className="ecosystempara2 home_p">
                  of the <b>NFT Marketplace fees</b> are used to buy
                  <br /> $LITTLE tokens from the exchange and burned them.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Ecosystem;
